import { ApiClient } from "~/clApi/main/foundation/ApiClient"
import { InformationListView } from "~/clApi/viewModel"

const basePath = "/internal_notification/user"

export const read = {
  getUserInformationList: () =>
    new ApiClient<InformationListView>().get(`${basePath}/information/list`),
}
